export default __webpack_public_path__ + "static/media/Gwent-Mod3-InCourseWorkbook.d56a2edf.pdf";